import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { TaskPropertyObject } from 'src/app/models/tasks/tasks-properties/task-properties.model';
import { ErrorPropertiesObject } from 'src/app/models/tasks/tasks-properties/error-properties/error-properties-object.model';
import { BusinessPropertiesObject } from 'src/app/models/tasks/tasks-properties/business-properties/business-properties-object.model';
import { ClientPropertiesObject } from 'src/app/models/tasks/tasks-properties/client-properties/client-properties-object.model';
import { TaskPropertiesObject } from 'src/app/models/tasks/tasks-properties/task-properties/task-properties-object.model';
import { TaskErrorPropertiesConverter } from './task-error-properties.converter';
import { TaskBusinessPropertiesConverter } from './task-business-properties.converter';
import { TaskClientPropertiesConverter } from './task-client-properties.converter';
import { TaskPropertiesConverter } from './task-properties.converter';

@Injectable({
    providedIn: 'root'
})
export class TaskPropertyConverter implements Converter<TaskPropertyObject>{

    constructor(private tasksErrorPropertiesConverter: TaskErrorPropertiesConverter,
        private tasksBusinessPropertiesConverter: TaskBusinessPropertiesConverter,
        private tasksClientPropertiesConverter: TaskClientPropertiesConverter,
        private taskPropertiesConverter: TaskPropertiesConverter) { }

    public convert(input: any): TaskPropertyObject {

        try {
            if (isNullOrUndefined(input)) return TaskPropertyObject.create();

            const errorProperties: ErrorPropertiesObject = this.tasksErrorPropertiesConverter.convert(input);
            const businessProperties: BusinessPropertiesObject = this.tasksBusinessPropertiesConverter.convert(input);
            const clientProperties: ClientPropertiesObject = this.tasksClientPropertiesConverter.convert(input);
            const taskProperties: TaskPropertiesObject = this.taskPropertiesConverter.convert(input);
            const properties: TaskPropertyObject = new TaskPropertyObject(businessProperties, clientProperties, errorProperties, taskProperties);
            return properties;

        } catch (error) {
            console.error(error);
            return TaskPropertyObject.create();
        }
    }

}
